import { defineStore } from 'pinia'
export interface TabIn {
  name: string
  path: string
  meta: any
}

export interface TabParams {
  serviceSiteCode: string
  startTime: string
  endTime: string
}

export const useTabStore = defineStore('tabs', {
  state: () => ({
    tabs: [] as TabIn[],
    tabsParams: {} as TabParams
  }),
  getters: {
    getTabs: (state) => state.tabs,
    getTabsParams: (state) => state.tabsParams
  },
  actions: {
    setTabs(menuItem: TabIn) {
      //白名单数组
      const whiteListArray = ['/notFound', '/noAuth','/login']
      if (whiteListArray.includes(menuItem.path)) return

      const findItem = this.tabs?.find((_) => _.path === menuItem.path)
      const findItemIndex = this.tabs?.findIndex((_) => _.path === menuItem.path)
      if (!findItem) {
        this.tabs.push(menuItem)
      } else {
        this.tabs[findItemIndex] = menuItem
      }
    },
    setTabsParams(params: TabParams) {
      this.tabsParams = params
    },
    delTabs(path: string) {
      const index = this.tabs.findIndex((_) => _.path === path)
      this.tabs.splice(index, 1)
    }
  },
  persist: {
    storage: localStorage
  }
})
